const { ControllerStyles } = require('../../../../components/ControllerStyles');
const { Knob } = require('../../../../components/Knob');

const Reverb = ({ settings, onUpdate }) => (
   <div>
      <svg width={500} height={500}>
         <ControllerStyles>
            <Knob
               x={50}
               y={50}
               diameter={50}
               value={settings.decay.value}
               onChange={(value) =>
                  onUpdate({ decay: { value: { $set: value } } })
               }
            />
            <Knob
               x={50}
               y={100}
               diameter={50}
               value={settings.predelay.value}
               onChange={(value) =>
                  onUpdate({ predelay: { value: { $set: value } } })
               }
            />
            <Knob
               x={100}
               y={50}
               diameter={50}
               value={settings.dry.value}
               onChange={(value) =>
                  onUpdate({ dry: { value: { $set: value } } })
               }
            />
            <Knob
               x={100}
               y={100}
               diameter={50}
               value={settings.wet.value}
               onChange={(value) =>
                  onUpdate({ wet: { value: { $set: value } } })
               }
            />
            <Knob
               x={150}
               y={50}
               diameter={50}
               value={settings.preWidth.value}
               onChange={(value) =>
                  onUpdate({ preWidth: { value: { $set: value } } })
               }
            />
            <Knob
               x={150}
               y={100}
               diameter={50}
               value={
                  settings.color.value === 'white'
                     ? 1
                     : settings.color.value === 'pink'
                     ? 0.5
                     : 0
               }
               onChange={(value) => {
                  let mappedVal = 'brown';
                  if (value > 0.33) {
                     mappedVal = 'pink';
                  }
                  if (value > 0.66) {
                     mappedVal = 'white';
                  }
                  onUpdate({ color: { value: { $set: mappedVal } } });
               }}
            />
         </ControllerStyles>
      </svg>
   </div>
);

export { Reverb };
